import { isNil } from 'lodash';

import { navigate } from '../libs/router';
import { Querystring } from './url';

import type { LocationWindow } from 'types';

export function updateQueryParams(location: LocationWindow, delta: {}) {
  const params = { ...location.query, ...delta };

  const queryString = Querystring.objectToString(params);
  navigate.replace(`${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`);
}

export function getStateFromCurrentLocation<T extends {}>(location: LocationWindow, defaultState: T): T {
  const query = location.query || {};
  const finalState = { ...defaultState };
  Object.keys(defaultState)
    .forEach((key) => {
      if (!isNil(query[key])) {
        if (typeof defaultState[key] === 'boolean') {
          finalState[key] = query[key] === 'true';
        } else if (typeof defaultState[key] === 'string') {
          finalState[key] = query[key];
        } else if (typeof defaultState[key] === 'number') {
          finalState[key] = Number(query[key]);
        }
      }
    });
  return finalState;
}
